module.exports = __webpack_public_path__ + "static/media/volunteer_activism_black_24dp.060010da.svg";